// extracted by mini-css-extract-plugin
export default {"message":"Message_message__1CEY6","error":"Message_error__fj3ao","success":"Message_success__Z5F9N","info":"Message_info__g7j-d","warning":"Message_warning__XVMYg"};